module.exports = __webpack_public_path__ + "img/HR.89786127.png";